// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/clear_button.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilterSidebar_sidebar_bg__QsJXG {
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  border-left: 1px solid #e0e0e0;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.05);
  padding: 24px;
  z-index: 100;
  overflow-y: auto;
  transition: transform 0.3s ease;
}

.FilterSidebar_sidebar__khyo- {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background-color: #fff;
  border-left: 1px solid #e0e0e0;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.05);
  padding: 48px 24px;
  z-index: 100;
  overflow-y: auto;
  transition: transform 0.3s ease;
}

.FilterSidebar_header__XfFHz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.FilterSidebar_buttonWrapper__Xa2mB {
  display: flex;
  justify-content: flex-end;
}


.FilterSidebar_headerText__GgYFD {
  font-size: 24px;
  font-weight: bold;
}

.FilterSidebar_closeButton__aKKSS {
  width: 40px;
  height: 45px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});  
  background-repeat: no-repeat;
  cursor: pointer;
}

.FilterSidebar_section__5PgcC {
  margin-bottom: 24px;
}

.FilterSidebar_sectionPrice__F7Yt- {
  margin-bottom: 24px;
  text-align: left;
}

.FilterSidebar_dateInput__olLQa,
.FilterSidebar_rangeInput__D39b6 {
  width: 100%;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-top: 6px;
}

.FilterSidebar_priceDisplay__brYfJ {
  margin-top: 8px;
  font-size: 14px;
  color: #555;
  text-align: center;
}

.FilterSidebar_labelText__Qm64T {
  font-size: 16px;
  font-weight: bold;
}

.FilterSidebar_sectionCheckbox__thtYY {
  display: flex;
  gap: 24px; /* расстояние между чекбоксами */
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.FilterSidebar_checkboxContainer__k--Wc {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  gap: 10px;
}

.FilterSidebar_checkboxContainer__k--Wc input {
  opacity: 0;
  position: absolute;
}

.FilterSidebar_customCheckbox__m3oB4 {
  width: 18px;
  height: 18px;
  background-color: white;
  border: 2px solid #1D8752;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.FilterSidebar_checkboxContainer__k--Wc input:checked + .FilterSidebar_customCheckbox__m3oB4 {
  background-color: #1D8752;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
}

.FilterSidebar_checkboxLabel__LDaEk {
  font-size: 14px;
  color: #333;
}

.FilterSidebar_applyButton__5RTe6 {
  padding: 10.5px 16px;
  background-color: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.FilterSidebar_overlay__1ZCbk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3); /* полупрозрачный чёрный */
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.FilterSidebar_overlay__1ZCbk.FilterSidebar_visible__2Fbts {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/styles/FilterSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;;AAGA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAA+C;EAC/C,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,gCAAgC;EAC3C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,0BAA0B;EAChE,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":[".sidebar_bg {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-left: 1px solid #e0e0e0;\n  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  z-index: 100;\n  overflow-y: auto;\n  transition: transform 0.3s ease;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 400px;\n  height: 100%;\n  background-color: #fff;\n  border-left: 1px solid #e0e0e0;\n  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.05);\n  padding: 48px 24px;\n  z-index: 100;\n  overflow-y: auto;\n  transition: transform 0.3s ease;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.buttonWrapper {\n  display: flex;\n  justify-content: flex-end;\n}\n\n\n.headerText {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.closeButton {\n  width: 40px;\n  height: 45px;\n  background-image: url(/public/clear_button.png);  \n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.section {\n  margin-bottom: 24px;\n}\n\n.sectionPrice {\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.dateInput,\n.rangeInput {\n  width: 100%;\n  padding: 6px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-top: 6px;\n}\n\n.priceDisplay {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #555;\n  text-align: center;\n}\n\n.labelText {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.sectionCheckbox {\n  display: flex;\n  gap: 24px; /* расстояние между чекбоксами */\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  gap: 10px;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  position: absolute;\n}\n\n.customCheckbox {\n  width: 18px;\n  height: 18px;\n  background-color: white;\n  border: 2px solid #1D8752;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: #1D8752;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.checkboxLabel {\n  font-size: 14px;\n  color: #333;\n}\n\n.applyButton {\n  padding: 10.5px 16px;\n  background-color: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3); /* полупрозрачный чёрный */\n  z-index: 999;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.overlay.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar_bg": `FilterSidebar_sidebar_bg__QsJXG`,
	"sidebar": `FilterSidebar_sidebar__khyo-`,
	"header": `FilterSidebar_header__XfFHz`,
	"buttonWrapper": `FilterSidebar_buttonWrapper__Xa2mB`,
	"headerText": `FilterSidebar_headerText__GgYFD`,
	"closeButton": `FilterSidebar_closeButton__aKKSS`,
	"section": `FilterSidebar_section__5PgcC`,
	"sectionPrice": `FilterSidebar_sectionPrice__F7Yt-`,
	"dateInput": `FilterSidebar_dateInput__olLQa`,
	"rangeInput": `FilterSidebar_rangeInput__D39b6`,
	"priceDisplay": `FilterSidebar_priceDisplay__brYfJ`,
	"labelText": `FilterSidebar_labelText__Qm64T`,
	"sectionCheckbox": `FilterSidebar_sectionCheckbox__thtYY`,
	"checkboxContainer": `FilterSidebar_checkboxContainer__k--Wc`,
	"customCheckbox": `FilterSidebar_customCheckbox__m3oB4`,
	"checkboxLabel": `FilterSidebar_checkboxLabel__LDaEk`,
	"applyButton": `FilterSidebar_applyButton__5RTe6`,
	"overlay": `FilterSidebar_overlay__1ZCbk`,
	"visible": `FilterSidebar_visible__2Fbts`
};
export default ___CSS_LOADER_EXPORT___;
